import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import WorkConfidenceButton from './components/WorkConfidenceButton/WorkConfidenceButton';
import WorkConfidenceSetAppElement from './components/WorkConfidenceButton/WorkConfidenceSetAppElement';

ReactDOM.render(
    <WorkConfidenceButton
        already_downloaded={can_download_survey} 
    />,
    document.getElementById('work-confidence-button')
);

ReactDOM.render(
    <WorkConfidenceSetAppElement/>,
    document.getElementById('set-app-element')
);
